import React, { useState } from 'react';
import { Card, Btn, Divider, Header, BottomNav, AlertCircleIcon, CopyIcon } from '../components/SharedComponents';
import C from '../styles/tokens';

const Withdraw = ({ navigate }) => {
  const [network,  setNetwork]  = useState('TRC20');
  const [amount,   setAmount]   = useState('100');
  const [address,  setAddress]  = useState('');

  const fee       = 1;
  const available = 510.44;
  const receive   = amount ? Math.max(0, parseFloat(amount) - fee) : 0;
  const isLow     = amount && parseFloat(amount) > available;
  const canSubmit = amount && address && !isLow;

  const handlePaste = () => {
    navigator.clipboard?.readText?.().then(t => setAddress(t)).catch(() => {});
  };

  return (
    <div className="page-wrapper fade-in">
      <Header title="Withdraw USDT" onBack={() => navigate('dashboard')} />

      <div className="page-content">

        {/* Main Form Card */}
        <Card style={{ marginBottom: 14 }}>

          {/* Available Balance */}
          <div className="flex justify-between items-center mb-14">
            <span style={{ fontSize: 13, color: C.textMuted }}>Available Balance</span>
            <span className="font-mono" style={{ fontWeight: 800, fontSize: 16, color: C.textPrimary }}>
              {available} USDT
            </span>
          </div>

          {/* Network Selector */}
          <div style={{ marginBottom: 16 }}>
            <div className="label-upper">Network</div>
            <div className="network-selector">
              {['TRC20', 'BEP20'].map(net => (
                <button
                  key={net}
                  className={`network-btn ${network === net ? 'network-btn-active' : 'network-btn-inactive'}`}
                  onClick={() => setNetwork(net)}
                >
                  {net}
                </button>
              ))}
            </div>
          </div>

          {/* USDT Amount */}
          <div style={{ marginBottom: 16 }}>
            <div className="label-upper">USDT Amount</div>
            <div className="input-wrap">
              <input
                type="number"
                value={amount}
                onChange={e => setAmount(e.target.value)}
                placeholder="Enter amount"
                className={`form-input form-input-number ${
                  isLow ? 'border-danger' : amount && !isLow ? 'border-accent' : ''
                }`}
              />
              <button className="input-max-btn" onClick={() => setAmount(String(available))}>
                MAX
              </button>
            </div>
            <div style={{ fontSize: 12, color: C.textMuted, marginTop: 6 }}>
              Max: {available} USDT
            </div>
            {isLow && (
              <div className="alert-error">
                <AlertCircleIcon />
                <span style={{ fontSize: 12, color: C.danger, fontWeight: 600 }}>
                  Insufficient balance! You only have {available} USDT
                </span>
              </div>
            )}
          </div>

          {/* Wallet Address */}
          <div style={{ marginBottom: 4 }}>
            <div className="label-upper">Withdraw To</div>
            <div className="input-wrap">
              <input
                type="text"
                value={address}
                onChange={e => setAddress(e.target.value)}
                placeholder={`Paste your ${network} USDT wallet address`}
                className={`form-input form-input-text ${address ? 'border-primary' : ''}`}
              />
              <button className="input-paste-btn" onClick={handlePaste}>
                <CopyIcon />
              </button>
            </div>
          </div>
        </Card>

        {/* Withdrawal Summary */}
        <Card style={{ marginBottom: 16, background: C.surface }}>
          <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 12, color: C.textPrimary }}>
            Withdrawal Summary
          </div>
          {[
            { label: 'Network Fee',       val: `${fee} USDT`,     valColor: C.danger },
            { label: 'You Will Receive',  val: `${receive} USDT`, valColor: C.accent },
          ].map((row, i) => (
            <div key={i}>
              {i > 0 && <Divider />}
              <div className="summary-row">
                <span style={{ fontSize: 13, color: C.textMuted }}>{row.label}</span>
                <span className="font-mono" style={{ fontWeight: 800, fontSize: 15, color: row.valColor }}>
                  {row.val}
                </span>
              </div>
            </div>
          ))}
        </Card>

        {/* Submit Button */}
        <Btn
          onClick={() => canSubmit && navigate('withdrawalSubmitted')}
          variant="primary" full size="lg"
          disabled={!canSubmit}
        >
          Withdraw Now
        </Btn>
      </div>

      <BottomNav active="withdraw" navigate={navigate} />
    </div>
  );
};

export default Withdraw;
